// Development Environment
const DEV_CONFIG = {
  BACKEND_URL: "https://api.dessertyard.ca",
  HOST: "www.dessertyard.ca",
};
// const DEV_CONFIG = {
//   BACKEND_URL: "http://localhost:5000",
//   HOST: "www.dessertyard.ca",
// };

// Production Environment
const PROD_CONFIG = {
  BACKEND_URL: process.env.VUE_APP_BACKEND || DEV_CONFIG.BACKEND_URL,
  HOST: process.env.VUE_APP_HOST || DEV_CONFIG.HOST,
};

const CONFIGS = {
  dev: DEV_CONFIG,
  prod: PROD_CONFIG,
};

export const CONFIG = CONFIGS.prod;

export default {
  CONFIG: CONFIG,
};
